<div class="content-body">
    <p class="header-text d-flex justify-space-between align-items-center">
        Report Settings 
      <button
        mat-button
        class="header-text-close d-flex align-items-center"
        disableRipple
        (click)="onCloseClick()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </p>
    
    <div class="content-right-button d-flex align-items-center gap-10 mb-1" style="display:none !important;">
        <span class="fw-bold">Accounting standard: </span>
        <mat-form-field appearance="fill" class="w-200 light-bg">
            <input
              matInput
              required
              autocomplete="off"
              value="FRS102"
              [readonly]="true"
            />
        </mat-form-field>
    </div>

    <div>
      <p class="fw-bold">Contacts</p>
        <mat-tab-group
          mat-align-tabs="start"
          disableRipple
          animationDuration="0ms"
          (selectedTabChange)="onTabChange($event)">
          
          <mat-tab *ngFor="let tab of tabList" [label]="tab.name">
            <div class="d-flex justify-space-between wp-100 mt-10">
              <button
                [disabled]="!isAddingAllowed || (isViewPermission$ | async)"
                class="action-button primary-button add-btn"
                mat-button
                disableRipple
                (click)="openEditDialog(true, undefined, tab.name)">
                <mat-icon>add</mat-icon> {{ tab.buttonLabel }}
              </button>
            </div>
            
            <div class="mat-table-wrapper report-grid mt-1">
              <table
                mat-table
                [dataSource]="dataSource"
                aria-describedby="Main Grid Table">

                <!-- Columns -->
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef>Name</th>
                  <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                </ng-container>

                <ng-container matColumnDef="address">
                  <th mat-header-cell *matHeaderCellDef>Address</th>
                  <td mat-cell *matCellDef="let element">
                    {{ formatAddress(element, false) }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>Actions</th>
                  <td mat-cell *matCellDef="let element">
                    <div class="grid-actions">
                      <div class="d-flex align-items-center">
                        <button
                          mat-button
                          disableRipple
                          title="Edit"
                          (click)="openEditDialog(true, element, tab?.name)">
                          <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
                        </button>
                        <button
                          *ngIf="!element.isLinked"
                          mat-button
                          title="Delete"
                          disableRipple
                          (click)="onDeleteClick(element.id, true)">
                          <mat-icon>delete_outline</mat-icon>
                        </button>
                      </div>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

              </table>
            </div>
          </mat-tab>
        </mat-tab-group>

        <div>
          <p class="fw-bold mt-2 mb-2">Independant Examiner</p>
          <div class="d-flex justify-space-between wp-100 mt-10">
            <button
              class="action-button primary-button add-btn"
              mat-button
              disableRipple
              [disabled]="(isViewPermission$ | async)"
              (click)="openEditDialog(false)"
              >
              <mat-icon>add</mat-icon> Add New Examiner
            </button>
          </div>
          <div class="mat-table-wrapper report-grid mt-1">
            <table
              mat-table
              [dataSource]="examinersDataSource"
              aria-describedby="Main Grid Table"
            >
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let element">{{ element.name }} {{element?.lastName}}</td>
              </ng-container>
              <ng-container matColumnDef="address">
                <th mat-header-cell *matHeaderCellDef>Address</th>
                <td mat-cell *matCellDef="let element">{{ formatAddress(element, true) }}</td>
              </ng-container>
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let element">
                    <div class="grid-actions">
                      <div class="d-flex align-items-center">
                        <button
                          mat-button
                          disableRipple
                          title="Edit"
                          (click)="openEditDialog(false, element)"
                        >
                          <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
                        </button>
                        <button
                          *ngIf="!element.isLinked"
                          mat-button
                          title="Delete"
                          disableRipple
                          (click)="onDeleteClick(element.id, false)"
                        >
                          <mat-icon>delete_outline</mat-icon>
                        </button>
                      </div>
                    </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>
        </div>
    
        <div class="d-flex gap-30 " *ngIf="iscompanyRegistered">
          <div *ngIf="isCharitablecompany">
            <p class="fw-bold font-size-18 mt-2 mb-2">Trustees' Report Disclosures</p>
            <div class="notes-view">
                <div *ngFor="let report of trusteeReports" class="d-flex align-items-center gap-10 mb-10">
                    <mat-checkbox [(ngModel)]="report.isChecked" (change)="onCheckboxClick($event, report, 'trustees')">
                        <p class="mb-0">{{ report.title }}</p>
                    </mat-checkbox>
                    <button mat-button disableRippl [disabled]="!report.isChecked">
                      <mat-icon [ngStyle]="{'cursor': !report.isChecked ?  'none' : 'pointer'}" (click)="getTrusteesDataById(report.type)" fontSet="material-icons-outlined">edit</mat-icon>
                    </button>
                  </div>
            </div>
          </div>
    
          <div>
            <p class="fw-bold font-size-18 mt-2 mb-2">Balance Sheet Disclosures</p>
            <div class="notes-view">
                <div *ngFor="let report of balancesheetReports" class="d-flex align-items-center gap-10 mb-10">
                    <mat-checkbox [(ngModel)]="report.isChecked" (change)="onCheckboxClick($event, report, 'balanceSheet')">
                        <p class="mb-0">{{ report.title }}</p>
                    </mat-checkbox>
                    <button mat-button disableRippl [disabled]="!report.isChecked">
                      <mat-icon [ngStyle]="{'cursor': !report.isChecked ?  'none' : 'pointer'}" (click)="getBalancesheetDataById(report.type)" fontSet="material-icons-outlined">edit</mat-icon>
                    </button>
                  </div>
            </div>
          </div>
        </div>
    </div>
</div>